import { h } from "preact";
import LinkList from "../link-list";

const QuotesList = ({ ...props }) => (
  <LinkList
    database="roman"
    dbType="citationkeywordlist"
    resultLinkPath={`${props.locale}/quotes/keyword`}
    resultLinkPathIdKey="id"
    textKey="trefwoord"
    filterKey="trefwoord"
    {...props}
  />
);

export default QuotesList;
